import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BlueArrowDown } from "../../assets/InterBranch/SVGIcons/icons";
import {
  getCountryArray,
  getCountryDetailsByCountryCode,
} from "../../constants/country";
import CountryList from "./CountryList";
import "./phoneinputv2.css";

function CustomPhoneInputV2({
  placeholder,
  onChange,
  name,
  defaultvalue,
  defaultCountryCode,
  theme,
  disabled,
  onBlur,
  value,
}) {
  let [selecedCountry, selectCountry] = useState({
    name: "India",
    flag: "🇮🇳",
    code: "IN",
    dial_code: "+91",
  });
  let [countryArray, setCountryArray] = useState(getCountryArray());
  let [isListOpen, setListOpen] = useState(false);
  let [number, setNumber] = useState();
  let [countycode, Setcountrcode] = useState(
    sanitizeCountryCode(defaultCountryCode)
  );
  let listRef = useRef();
  let inputRef = useRef();

 
  useEffect(() => {
    setNumber(defaultvalue);
    loadDefaultCountry();
  }, []);

  useEffect(() => {
    setNumber(value);
    loadDefaultCountry();
  }, [value]);

  useEffect(() => {
    loadDefaultCountry();
  }, [defaultCountryCode]);

  const loadDefaultCountry = async () => {
    if (countycode.length > 0) {
      const sel = await getCountryDetailsByCountryCode(
        sanitizeCountryCode(defaultCountryCode)
      );

      selectCountry(sel);
    } else {
      console.log("sel else");
    }
  };

  function handleCountryCodeSelect(e, value) {
    selectCountry(value);
    setListOpen(!isListOpen);

    let data = {
      name: value?.name,
      dialCode: value?.dial_code?.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
      countryCode: value?.code,
      number,
    };

    onChange(
      number,
      `${selecedCountry?.dial_code?.replace(
        /[&\/\\#,+()$~%.'":*?<>{}]/g,
        ""
      )} ${number}`,
      data,
      inputRef.current
    );
  }

  let handleInputChange = (e) => {
    setNumber(e.target.value);

    let value = e.target.value;

    let data = {
      name: selecedCountry?.name,
      dialCode: selecedCountry?.dial_code?.replace("+", ""),
      countryCode: selecedCountry?.code,
      number: value,
    };

    onChange(
      value,
      `${selecedCountry?.dial_code?.replace(
        /[&\/\\#,+()$~%.'":*?<>{}]/g,
        ""
      )} ${value}`,
      data,
      e
    );
  };

  function allowOnlyNumericsOrDigits(e) {
    !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"].includes(
      e.key
    ) && e.preventDefault();
  }

  const getTheme = (theme) => {
    switch (theme) {
      case "signin":
        return "phone-input-v2-container-signin";
      case "white-theme":
        return "phone-input-v2-container-white";

      default:
        break;
    }
  };

  function sanitizeCountryCode(code) {
    return code ? (code.indexOf("+") >= 0 ? code : `+${code}`) : "+91";
  }

  return (
    <div
      className={`phone-input-v2-container ${getTheme(theme)} ${
        disabled && "phone-input-v2-disabled"
      }`}
    >
      <div
        className="country-code-container"
        onClick={() => {
          !disabled && setListOpen(!isListOpen);
        }}
      >
        {/* <img className='flag-image' src={`https://countryflagsapi.com/png/${selecedCountry ? selecedCountry.code : "india"}`} alt="" /> */}
        <img
          className="flag-image"
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${
            selecedCountry ? selecedCountry.code : "IN"
          }.svg`}
          alt=""
        />

        <span className="country-code-text">{selecedCountry?.dial_code}</span>

        <BlueArrowDown />

        {isListOpen && (
          <CountryList
            setOpen={setListOpen}
            isListOpen={isListOpen}
            ref={listRef}
            countryArray={countryArray}
            onClick={handleCountryCodeSelect}
          />
        )}
      </div>

      <div className="phone-input-v2-divider"></div>

      <input
        disabled={disabled}
        onBlur={onBlur ? onBlur : () => {}}
        ref={inputRef}
        maxLength={12}
        name={name}
        value={number}
        onKeyDown={(e) => {
          e.key === "Enter" ? e.preventDefault() : allowOnlyNumericsOrDigits(e);
        }}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="mobile-number-input"
        type="mobile"
        autoComplete="off"
      />
    </div>
  );
}

export default CustomPhoneInputV2;
